// Shared press/media constants — single source of truth for the
// Google Drive media folder + press contact info used across the
// /press-release, /media-kit and /press pages.

export const MEDIA_FOLDER_URL =
  "https://drive.google.com/drive/folders/1Cs5g-3PpexWPe3RuPlo8eb-4zB7nOCGU?usp=sharing";

export const MEDIA_FOLDER_LABEL = "Press image library";

export const PRESS_EMAIL = "info@nickfraserartist.com";

export const PRESS_EMAIL_SUBJECT =
  "Press%20enquiry%20%E2%80%94%20Nick%20Fraser%3A%20Chapter%20II";
